<div class="group">
  <div class="block block_first">
    <div class="group__photo">
      <tui-avatar
        [src]="chat && chat.userPhotoPath ? (chat.userPhotoPath | safe: 'url') : (chat?.title ?? '' | tuiInitials)"
        [size]="'l'"
        [round]="true"
        [style.background]="
          chat && !chat.userPhotoPath && chat.title ? (chat.title | tuiAutoColor) : ('' | tuiAutoColor)
        "
      ></tui-avatar>
    </div>

    <div class="group__name">{{ chat?.title }}</div>

    <div *ngIf="superGroup" class="group__status">
      {{ superGroup.memberCount | numeralPlurals: ['участник', 'участника', 'участников'] }}
    </div>

    <div *ngIf="basicGroup" class="group__status">
      {{ basicGroup.members.length | numeralPlurals: ['участник', 'участника', 'участников'] }}
    </div>
  </div>

  <div *ngIf="organisation" class="block block_info">
    <tui-data-list>
      <button tuiOption class="organisation" [routerLink]="'/organisation/' + organisation.organisationId">
        <app-icon class="organisation__icon" [src]="'building-2'" size="24px"></app-icon>

        <span class="organisation__title">
          {{ organisation.organisationName }}
        </span>
      </button>
    </tui-data-list>
  </div>

  <div class="block block_info">
    <tui-data-list>
      <button tuiOption class="notifications" (click)="onChangeNotificationsToggleValue()">
        <app-toggle [ngModel]="!!chat && chat.notificationSettings.muteFor === 0" [size]="'m'"></app-toggle>

        <span class="notifications__title">
          {{ 'common.labels.notifications' | translate }}
        </span>
      </button>
    </tui-data-list>
  </div>

  <div *ngIf="members.length" class="block block_info">
    <app-users-list
      [isChannel]="isChannel"
      [memberCount]="memberCount"
      [chatId]="chat?.id"
      [members]="members"
      (changeMembers)="getMembers()"
      (selectedUserIdChange)="onUserIdChange($event)"
    ></app-users-list>
  </div>
</div>
